import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { MarketTypes } from 'api/types';

export type APIBuildingSearchRes = {
  buildings: TBuildingStreetWrapper[];
};

export type TBuildingStreetWrapper = {
  streetName: string;
  cityName: string;
  buildings: TBuilding[];
};

export type TBuilding = {
  id: number;
  house: string;
  countFacilites: number;
  coordinates: {
    latitude: number;
    longitude: number;
  };
};

export const useBuildingSearch = () => {
  const { data, error, isLoading } = useSWR('/building/search', (url) =>
    fetcher
      .swr<APIBuildingSearchRes>(url, {
        params: { marketType: MarketTypes.SECONDARY },
      })
      .then((res) => {
        return res?.buildings;
      }),
  );

  return {
    buildings: data ?? [],
    error,
    isLoading,
  };
};
